export const ValidationMessage = ({error, touched}) => {
  if (error && touched) {
    return <span className="form-error">{error}</span>
  }

  return null;
}

export const ForceValidationMessage = ({error}) => {
  if (error) {
    return <span className="form-error">{error}</span>
  }

  return null;
}